import { render, staticRenderFns } from "./Logistics.vue?vue&type=template&id=136a0d39&scoped=true"
import script from "./Logistics.vue?vue&type=script&lang=js"
export * from "./Logistics.vue?vue&type=script&lang=js"
import style0 from "./Logistics.vue?vue&type=style&index=0&id=136a0d39&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136a0d39",
  null
  
)

export default component.exports